import { render, staticRenderFns } from "./HeaderMenuAside.vue?vue&type=template&id=344d60a5&scoped=true"
import script from "./HeaderMenuAside.vue?vue&type=script&lang=js"
export * from "./HeaderMenuAside.vue?vue&type=script&lang=js"
import style0 from "./HeaderMenuAside.vue?vue&type=style&index=0&id=344d60a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344d60a5",
  null
  
)

export default component.exports